var React = require('react');

function CloseGray (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#bcc6c6","fillRule":"nonzero","d":"M13 11.02L20.02 4 22 5.98 14.98 13 22 20.02 20.02 22 13 14.98 5.98 22 4 20.02 11.02 13 4 5.98 5.98 4 13 11.02z"}));
}

CloseGray.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26"};

module.exports = CloseGray;

CloseGray.default = CloseGray;
